export const CONTACT = {
  owner: "Malermeister Manfred Berglar",
  brand: "Manfred Berglar · Malermeister seit 1925",
  street: "Höhweg 14",
  city: "57462 Olpe-Griesemert",
  phoneDisplay: "0 27 61 / 6 50 64",
  phoneHref: "tel:+49276165064",
  email: "info@maler-berglar.de",
  mapsQuery: "Höhweg 14, 57462 Olpe-Griesemert",
};

export const NAV_LINKS = [
  { id: "start", label: "Start", to: "/" },
  { id: "leistungen", label: "Leistungen", to: "/leistungen" },
  { id: "referenzen", label: "Referenzen", to: "/referenzen" },
  { id: "ueber-uns", label: "Über uns", to: "/ueber-uns" },
  { id: "karriere", label: "Karriere", to: "/karriere" },
];

export const AUDIENCE_LINKS = [
  { id: "privat", label: "Privatkunden", to: "/privat" },
  { id: "unternehmen", label: "Unternehmen", to: "/unternehmen" },
  { id: "kommunen", label: "Städte & Gemeinden", to: "/kommunen" },
];

export const IMAGES = {
  hero: "/images/ci5/olpe-aerial.jpg",
  privat: "/images/ci7/privat.jpg",
  unternehmen: "/images/ci7/unternehmen.jpg",
  kommunen: "/images/ci7/kommunen.jpg",
  fassadengestaltung: "/images/marke/villa-logo.jpg",
  fassadensanierung: "/images/marke/spachtel-logo.jpg",
  innenraum: "/images/marke/wohnzimmer-logo.jpg",
  innenraumPreview: "/images/ci7/innenraum.jpg",
  malerarbeiten: "/images/marke/rolle-logo.jpg",
  putz: "/images/marke/stuck-arbeit.jpg",
  renovierung: "/images/marke/renovierung-logo.jpg",
  history: "/images/team/team.jpg",
  before: "/images/ci7/before.jpg",
  after: "/images/ci7/fassade.jpg",
  detailarbeit: "/images/team/beratung-material.jpg",
  farbrolle: "/images/ci7/materialien.jpg",
  held: "/images/ci7/held.jpg",
  region: "/images/ci7/region.jpg",
};

export const TRUST_ITEMS = [
  { value: "1925", label: "Gegründet in Griesemert" },
  { value: "100+", label: "Jahre Meisterhandwerk" },
  { value: "3", label: "Zielgruppen: Privat · B2B · Kommunal" },
  { value: "1", label: "Inhabergeführter Meisterbetrieb" },
];

export const AUDIENCES = [
  {
    id: "privat",
    to: "/privat",
    image: IMAGES.privat,
    overline: "Privatkunden",
    title: "Ihr Zuhause. Unser Anspruch.",
    text: "Innenräume, Fassaden und Renovierungen für Eigentümer – sauber, termintreu, mit Farbberatung inklusive.",
  },
  {
    id: "unternehmen",
    to: "/unternehmen",
    image: IMAGES.unternehmen,
    overline: "Unternehmen & Verwaltungen",
    title: "Planbar. Skalierbar. Verlässlich.",
    text: "Büros, Praxen und Gewerbeflächen – mit Wartungsverträgen, Wochenendeinsätzen und festen Ansprechpartnern.",
  },
  {
    id: "kommunen",
    to: "/kommunen",
    image: IMAGES.kommunen,
    overline: "Städte & Gemeinden",
    title: "Verlässlich für die öffentliche Hand.",
    text: "Schulen, Kitas und öffentliche Gebäude – erfahren in Ausschreibungen, Rahmenverträgen und Termintreue.",
  },
];

export const AUDIENCE_PAGES = {
  privat: {
    overline: "Privatkunden",
    title: "Ihr Zuhause. Unser Anspruch.",
    sub: "Ob einzelner Raum, komplette Fassade oder behutsame Altbau-Renovierung: Wir arbeiten in Ihrem Zuhause so, wie wir es bei uns erwarten würden – geschützt, sauber und auf den Millimeter genau.",
    image: IMAGES.privat,
    points: [
      { icon: "Sparkles", title: "Sauberkeit ist Standard", text: "Böden, Möbel und Wege werden konsequent abgedeckt und geschützt. Übergeben wird besenrein – immer." },
      { icon: "Clock", title: "Termine, die halten", text: "Wir sagen verbindlich zu, wann wir kommen und wann wir fertig sind. Und wir halten es ein." },
      { icon: "Home", title: "Werterhalt Ihrer Immobilie", text: "Mineralische, langlebige Beschichtungen schützen Bausubstanz und Wert Ihres Zuhauses nachhaltig." },
      { icon: "Palette", title: "Farbberatung inklusive", text: "Von der Idee bis zum Musteranstrich: Wir finden den Ton, der zu Ihren Räumen und Ihrem Licht passt." },
    ],
    serviceIds: ["innenraum", "fassadengestaltung", "renovierung"],
    ctaTitle: "Ihr Projekt beginnt mit einem Gespräch.",
    ctaText: "Beschreiben Sie kurz Ihr Vorhaben – wir melden uns persönlich und verbindlich.",
  },
  unternehmen: {
    overline: "Unternehmen & Hausverwaltungen",
    title: "Planbar. Skalierbar. Verlässlich.",
    sub: "Büros, Praxen, Gewerbeflächen und Bestandsobjekte: Wir liefern Malerarbeiten, die sich in Ihren Betriebsablauf einfügen – nicht umgekehrt.",
    image: IMAGES.unternehmen,
    points: [
      { icon: "FileCheck", title: "Wartungsverträge", text: "Regelmäßige Instandhaltung mit festen Konditionen und dokumentierten Leistungen – planbar übers Jahr." },
      { icon: "Clock", title: "Arbeiten ohne Betriebsstopp", text: "Wochenend- und Abendeinsätze nach Absprache: Ihr Betrieb läuft weiter, wir arbeiten im Hintergrund." },
      { icon: "Users", title: "Fester Ansprechpartner", text: "Ein Meisterbetrieb, ein Ansprechpartner, eine Handschrift – von der Besichtigung bis zur Abnahme." },
      { icon: "Building2", title: "Hausverwaltungen", text: "Verlässliche Abwicklung für Bestand und Mieterwechsel – mit klarer Dokumentation und sauberer Übergabe." },
    ],
    serviceIds: ["malerarbeiten", "renovierung", "putz"],
    ctaTitle: "Lassen Sie uns über Ihre Flächen sprechen.",
    ctaText: "Beschreiben Sie Objekt und Zeithorizont – Sie erhalten ein klares, nachvollziehbares Angebot.",
  },
  kommunen: {
    overline: "Städte & Gemeinden",
    title: "Verlässlich für die öffentliche Hand.",
    sub: "Schulen, Kitas, Verwaltungs- und Gemeinschaftsgebäude: Als Meisterbetrieb seit 1925 bringen wir die Erfahrung mit, die öffentliche Aufträge verlangen – von der Ausschreibung bis zur förmlichen Abnahme.",
    image: IMAGES.kommunen,
    points: [
      { icon: "FileCheck", title: "Erfahren in Ausschreibungen", text: "Wir arbeiten nach VOL mit präzisen Leistungsbeschreibungen, transparenten Preisen und sauberer Dokumentation." },
      { icon: "ShieldCheck", title: "Rahmenverträge & Zuverlässigkeit", text: "Langfristige Zusammenarbeit mit Bauhöfen und Liegenschaftsämtern – termintreu, budgettreu, nachweisbar." },
      { icon: "Landmark", title: "Stabilität seit 1925", text: "Ein Jahrhundert wirtschaftliche Beständigkeit: Auf uns ist auch nach Projektende Verlass." },
      { icon: "HeartHandshake", title: "Regionale Verantwortung", text: "Wir arbeiten dort, wo wir leben – kurze Wege, schnelle Reaktionszeiten, echte Verbundenheit mit der Region." },
    ],
    serviceIds: ["fassadensanierung", "malerarbeiten", "renovierung"],
    ctaTitle: "Ausschreibung oder Direktauftrag?",
    ctaText: "Senden Sie uns Ihre Leistungsbeschreibung oder rufen Sie direkt an – wir kalkulieren verbindlich.",
  },
};

export const SERVICES = [
  {
    id: "fassadengestaltung",
    num: "01",
    icon: "Building2",
    title: "Fassadengestaltung",
    image: IMAGES.fassadengestaltung,
    text: "Eine Fassade ist das Gesicht Ihres Gebäudes. Wir entwickeln Farb- und Materialkonzepte, die zur Architektur passen – präzise ausgeführt, mit Bestand.",
    tags: ["Farbkonzepte", "Mineralputze", "Architekturberatung"],
    prefill: "Fassadengestaltung",
  },
  {
    id: "fassadensanierung",
    num: "02",
    icon: "Layers",
    title: "Fassadensanierung",
    image: IMAGES.fassadensanierung,
    text: "Witterung hinterlässt Spuren. Wir sanieren Untergründe fachgerecht, schließen Risse und bauen Beschichtungen neu auf – damit Ihre Fassade wieder schützt und überzeugt.",
    tags: ["Risssanierung", "Untergrundaufbau", "Wetterschutz"],
    prefill: "Fassadensanierung",
  },
  {
    id: "innenraum",
    num: "03",
    icon: "Sofa",
    title: "Innenraumgestaltung",
    image: IMAGES.innenraum,
    text: "Räume prägen, wie Menschen leben und arbeiten. Mit sicherem Blick für Farbe, Licht und Proportion gestalten wir Innenräume mit klarer Wirkung.",
    tags: ["Farbkonzepte", "Wandgestaltung", "Akzentwände"],
    prefill: "Innenraumgestaltung",
  },
  {
    id: "malerarbeiten",
    num: "04",
    icon: "Paintbrush",
    title: "Malerarbeiten",
    image: IMAGES.malerarbeiten,
    text: "Das klassische Handwerk – präzise ausgeführt: Decken, Wände, Lackier- und Tapezierarbeiten. Sauber abgeklebt, sauber gearbeitet, sauber übergeben.",
    tags: ["Decken & Wände", "Lackierarbeiten", "Tapezierarbeiten"],
    prefill: "Malerarbeiten",
  },
  {
    id: "putz",
    num: "05",
    icon: "BrickWall",
    title: "Putz- & Oberflächenarbeiten",
    image: IMAGES.putz,
    text: "Mineralputze, Strukturputze, Glättetechniken: Oberflächen geben Gebäuden ihren Charakter. Wir beraten zu Material und Körnung – und führen es präzise aus.",
    tags: ["Mineralputze", "Strukturputze", "Glättetechnik"],
    prefill: "Putz- & Oberflächenarbeiten",
  },
  {
    id: "renovierung",
    num: "06",
    icon: "Hammer",
    title: "Renovierung & Modernisierung",
    image: IMAGES.renovierung,
    text: "Aus Bestand wird wieder Wert: Wir renovieren mit Respekt vor der Bausubstanz – vom einzelnen Raum bis zur durchdachten Modernisierung im Altbau.",
    tags: ["Altbau", "Modernisierung", "Komplettrenovierung"],
    prefill: "Renovierung / Modernisierung",
  },
];

export const QUALITY_LINES = [
  "Saubere Ausführung.",
  "Ehrliche Beratung.",
  "Meisterqualität seit 1925.",
];

export const QUALITY_POINTS = [
  { icon: "MessagesSquare", title: "Persönliche Beratung", text: "Sie sprechen direkt mit dem Meisterbetrieb – nicht mit einem Callcenter." },
  { icon: "Sparkles", title: "Saubere Ausführung", text: "Abdecken, schützen, präzise arbeiten: Ordnung auf der Baustelle ist für uns Standard." },
  { icon: "Layers", title: "Langlebige Materialien", text: "Mineralische, bewährte Produkte – abgestimmt auf Untergrund, Nutzung und Budget." },
  { icon: "Landmark", title: "Erfahrung seit 1925", text: "Gewachsenes Wissen aus Olpe-Griesemert – weitergegeben, verfeinert, gelebt." },
];

export const STEPS = [
  { num: "01", title: "Beratung", text: "Rufen Sie an oder schreiben Sie uns – wir hören zu und verstehen Ihr Vorhaben." },
  { num: "02", title: "Vor-Ort-Besichtigung", text: "Wir schauen uns Ihr Projekt direkt an – in Olpe, Wenden und im gesamten Südsauerland." },
  { num: "03", title: "Angebot", text: "Klar, nachvollziehbar und ohne versteckte Positionen." },
  { num: "04", title: "Saubere Ausführung", text: "Abgeklebt, geschützt, präzise gearbeitet – mit sauberer Übergabe." },
];

export const TESTIMONIALS = [
  {
    quote: "Von der Besichtigung bis zur Abnahme: sauber und verbindlich. Die Fassade sieht heute noch aus wie im ersten Jahr.",
    source: "Privathaushalt · Kreis Olpe · anonymisiert",
  },
  {
    quote: "Wochenendeinsatz, null Betriebsstopp, saubere Dokumentation. Genau so stellt man sich das als Gewerbetreibender vor.",
    source: "Gewerbebetrieb · Südsauerland · anonymisiert",
  },
  {
    quote: "Verlässliche Kalkulation, präzise Ausführung, formgerechte Abnahme. Eine Adresse, mit der wir weiter planen.",
    source: "Öffentliche Hand · Kreis Olpe · anonymisiert",
  },
];

export const PROJECTS = [
  {
    id: "fassade-olpe",
    file: "Vorgang 1925 / 084",
    category: "Fassadensanierung · Kreis Olpe",
    title: "Mineralische Fassade, komplett erneuert",
    image: IMAGES.fassadengestaltung,
    text: "Aus einer verwitterten Fläche wurde eine mineralische Fassade mit klarem Bildausschnitt – Untergrund saniert, Beschichtung neu aufgebaut, präzise ausgeführt.",
    scope: "Untergrundsanierung · Neuaufbau Beschichtung · 6 Wochen",
  },
  {
    id: "innenraum-griesemert",
    file: "Vorgang 1925 / 117",
    category: "Innenraumgestaltung · Südliches Sauerland",
    title: "Farbiges Konzept für ein Privathaus",
    image: IMAGES.innenraum,
    text: "Ein Farbkonzept aus Weiß und tiefem Akzentton: glatte Oberflächen, klare Flächen und ein Raumgefühl, das zu Licht und Nutzung passt.",
    scope: "Farbkonzept · Wände & Decken · 3 Wochen",
  },
  {
    id: "altbau-sauerland",
    file: "Vorgang 1925 / 132",
    category: "Renovierung · Öffentlicher Auftrag",
    title: "Altbau, behutsam erneuert",
    image: IMAGES.renovierung,
    text: "Stuck erhalten, Wände neu geglättet, Böden erneuert: Modernisierung mit Respekt vor der Bausubstanz – bis in die Details.",
    scope: "Denkmalgerechte Ausführung · 4 Monate",
  },
];

export const BEFORE_AFTER = {
  title: "Vom Ist-Zustand zum Ergebnis",
  text: "Ziehen Sie den Regler: Aus einer verwitterten Fassade wird ein gepflegtes Gesamtbild – Untergrund saniert, Oberfläche neu aufgebaut, präzise abgestimmt.",
};

export const CHAPTERS = [
  {
    year: "1925",
    title: "Die Gründung",
    text: "Franz Berglar Sen. gründet das Malergeschäft und lässt es in die Handwerksrolle eintragen – der Grundstein für einen Betrieb, der von Anfang an für saubere Arbeit, ehrliche Beratung und Verlässlichkeit steht.",
  },
  {
    year: "1967",
    title: "Die zweite Generation",
    text: "Am 14. November 1967 übernimmt Franz Berglar Jun. das Geschäft von seinem Vater und führt das Malerhandwerk mit derselben Sorgfalt durch die folgenden Jahrzehnte.",
  },
  {
    year: "1983",
    title: "Die dritte Generation",
    text: "Am 14. April 1983 wird der Betrieb an Manfred Berglar übergeben. Er führt die handwerkliche Tradition weiter – mit dem Anspruch, jedes Projekt auszuführen, als wäre es das eigene Zuhause.",
  },
  {
    year: "Heute",
    title: "Der Anspruch wächst",
    text: "Privatkunden, Unternehmen und Kommunen vertrauen auf Manfred Berglar, Malermeister seit 1925: moderne Technik, mineralische Materialien und ein geschulter Blick – persönlich, regional, verlässlich.",
  },
];

export const QUOTE =
  '„Gute Malerarbeit sieht man nicht nur. Man spürt sie – in Räumen, die stimmig wirken, und Fassaden, die ihren Charakter behalten.“';

export const FAQS = [
  {
    q: "Wie schnell erhalten wir einen Termin?",
    a: "Nach Ihrer Anfrage melden wir uns in der Regel innerhalb von zwei Werktagen. Vor-Ort-Besichtigungen in Olpe-Griesemert und Umgebung stimmen wir kurzfristig und verbindlich ab.",
  },
  {
    q: "Arbeiten Sie auch für öffentliche Auftraggeber?",
    a: "Ja. Wir sind erfahren in der Arbeit mit Städten, Gemeinden und Bauhöfen – von der Ausschreibung nach VOL über Rahmenverträge bis zur förmlichen Abnahme.",
  },
  {
    q: "Übernehmen Sie auch Aufträge für Unternehmen?",
    a: "Büros, Praxen, Gewerbeflächen und Bestandsobjekte gehören zu unserem Alltag – gern mit Wartungsvertrag und Arbeiten außerhalb Ihrer Betriebszeiten.",
  },
  {
    q: "Übernehmen Sie auch kleinere Arbeiten?",
    a: "Vom einzelnen Raum bis zur kompletten Fassade: Wir beraten jedes Vorhaben mit derselben Sorgfalt – unabhängig von der Größe.",
  },
  {
    q: "Was kostet ein Projekt?",
    a: "Das hängt von Untergrund, Fläche und Material ab. Nach der Besichtigung erhalten Sie ein klares, nachvollziehbares Angebot – ohne versteckte Positionen.",
  },
];

export const LEISTUNG_OPTIONS = [
  "Fassadengestaltung",
  "Fassadensanierung",
  "Innenraumgestaltung",
  "Malerarbeiten",
  "Putz- & Oberflächenarbeiten",
  "Renovierung / Modernisierung",
  "Kommunaler Auftrag / Ausschreibung",
  "Sonstiges",
];

export const FARBWELT_COLORS = [
  { id: "reinweiss", name: "Reinweiß", hex: "#F8FAFC", mood: "Klar und präzise – macht Räume großzügig und ruhig." },
  { id: "alabaster", name: "Abendcreme", hex: "#EFE8DF", mood: "Warm und edel – der Galerie-Ton der Olper Abendsonne." },
  { id: "graphit", name: "Tannengrün", hex: "#1E271C", mood: "Tief und souverän – der Wald der Region als Anker." },
  { id: "oxblood", name: "Bronze", hex: "#8A6D43", mood: "Warm und markant – wie Dächer und Abendlicht, unverwechselbar." },
  { id: "schiefer", name: "Biggesee-Grau", hex: "#B8C6CC", mood: "Ruhig und klar – das helle Grau des Sees am Morgen." },
  { id: "champagner", name: "Champagner", hex: "#C2A370", mood: "Edel und warm – für Akzente mit Tradition und Glanz." },
];
